import { Fragment, useEffect, useState } from "react";
import Header from "../../../components/common/secondary header/index";
import SchoolOverallReport from "./overall-report";
import SubTopicWiseReport from "./sub-topic-wise-report";
import "./style.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { TEACHER } from "../../../constants";
import CustomPaginatedTable from "./CustomPaginatedTable";
import { ArrowBack } from "../../../static/img/images";
import { subtopicReportReset, selectClass, selectCompetition, selectSchool } from '../../../store/actions'
import CustomSkillTable from "./CustomSkillTable";
import { CompetitionsService } from "../../../services/competitions";
import { showAlert } from "../../../store/config/actions";
import { ReportCompetitionsSubTopicService, ReportSchools, SchoolReportSubTopicWiseService } from "../../../services/reports";
import { textIdentifier } from "../../../textIdentifier";

export default function ReportBySchool() {
  const { userType } = useSelector((state) => state.auth);
  const [activeTab, setActiveTab] = useState(0);
  const { selectedCompetition, selectedSchool, schoolSubtopicOverallReportdata, activeTopic, schoolSubtopicSkillReportdata,lang } = useSelector(
    (state) => state.main
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const handleFetchCompetitions = async () => {
    try {
      const res = await CompetitionsService();
      let selectedCompId = location.pathname.split("/")[2]
      let selectedSchoolId = location.pathname.split("/")[4]
      let selectedComp;
      let selectedSchool;
      res.data.map((item,index)=>{
        if(item.id==selectedCompId){
          selectedComp=item
          dispatch(selectCompetition(item))
        }
      })


      // Fetch schools list here ----

      try {
        const res = await ReportSchools(selectedCompId);
        res.data.map((item,index)=>{
          if(item.id==selectedSchoolId){
            selectedSchool=item
          }
        })
      } catch (error) {
        console.log("error", error);
        // dispatch(showAlert(error?.data?.message));
      }


      // Fetch Subtopic for competition here -----
      let overallRes;
      try {
        const res = await ReportCompetitionsSubTopicService(selectedCompId);
        overallRes = res.data
        dispatch(
          selectCompetition({
            ...selectedComp,
            subTopicsWiseReportData: res.data,
          })
        );
      } catch (error) {
        dispatch(showAlert(error?.data?.message));
      }


      // Fetch Subtopic for school here ----
      try {
        let schoolSubTopicRes = await SchoolReportSubTopicWiseService(
          selectedCompId,
          selectedSchoolId
        );
        if(!!overallRes){
          dispatch(
            selectSchool({
                ...selectedSchool,
                percentile: overallRes.percentile,
                accuracy: overallRes.accuracy,
                proficiency: overallRes.proficiency,
                marks: overallRes.marks,
                subTopicData: schoolSubTopicRes.data,
                hide_skills: overallRes.hide_skills
            })
          );
        }
      }
      catch (error) {
        dispatch(showAlert(error?.data?.message));
      }

    } catch (error) {
      console.log(error)
      // dispatch(showAlert(error?.data?.message));
    } finally {
      
    }
  };

  useEffect(() => {
    if (!selectedCompetition || !selectedSchool) {
      handleFetchCompetitions()
      // navigate("/dashboard");
    }
  }, []);

  const renderCardJSX = () => {
    switch (activeTab) {
      case 1:
        return <SubTopicWiseReport />;
      default:
        return <SchoolOverallReport />;
    }
  };

  const handleTabChange = () => setActiveTab((pre) => (pre === 0 ? 1 : 0));

  if (!selectedCompetition || !selectedSchool) {
    return null;
  }

  if (userType === TEACHER) {
    return (
      <Fragment>
        <Header title={selectedCompetition.name} />
        {renderCardJSX()}
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Header title={selectedCompetition.name} />

      <main className="schools-report">
        {/* heading card */}
        <div className="card heading-card">
          <div className="card-body">
            <span className="card-title">
              {selectedSchool.name}{" "}
              {!selectedCompetition.hide_rank && <span className="text-primary">({textIdentifier["rank"][lang]}{" "}{selectedSchool.rank})</span>}
            </span>
            <Link
              to={`/report/${selectedCompetition.id}/schools/${selectedSchool.id}/classes`}
            >
              <button className={"btn-contained"}>{textIdentifier["classes"][lang]}</button>
            </Link>
          </div>
        </div>

        {/* content */}
        {
          schoolSubtopicOverallReportdata!=undefined?
          <div className="cr-wrapper-card">
          <button onClick={()=>{dispatch(subtopicReportReset())}} className="cr-back-btn"><ArrowBack/> {textIdentifier["back"][lang]}</button>
            <div className="cr-card sub-topic-wise-report">
              <CustomPaginatedTable activeTopic={!!activeTopic && activeTopic} data={!!schoolSubtopicOverallReportdata && schoolSubtopicOverallReportdata} />
            </div>
          </div>
          :
          schoolSubtopicSkillReportdata!=undefined?
          <div className="cr-wrapper-card">
          <button onClick={()=>{dispatch(subtopicReportReset())}} className="cr-back-btn"><ArrowBack/> {textIdentifier["back"][lang]}</button>
            <div className="cr-card sub-topic-wise-report">
              <CustomSkillTable activeTopic={!!activeTopic && activeTopic} data={!!schoolSubtopicSkillReportdata && schoolSubtopicSkillReportdata} />
            </div>
          </div>
          :
          <div className="cr-wrapper-card">
            <div className="cr-card-header">
              <button
                onClick={handleTabChange}
                className={
                  activeTab === 0
                    ? "btn-contained bg-primary"
                    : "btn-outlined bg-transparent"
                }
              >
                {textIdentifier["overall-report"][lang]}
              </button>
              <button
                onClick={handleTabChange}
                className={
                  activeTab === 1
                    ? "btn-contained bg-primary"
                    : "btn-outlined bg-transparent"
                }
              >
                {textIdentifier["subtopic-wise-report"][lang]}
              </button>
            </div>

            {renderCardJSX()}
          </div>
        }
      </main>
    </Fragment>
  );
}
